import React, { useRef } from "react";
import Cropper from "react-cropper";
import { Box } from "@chakra-ui/react";
import { ModalBox } from "../ModalBox";
import "react-cropper/node_modules/cropperjs/dist/cropper.css"

export const ImageCropper = ({
    file,
    isOpen,
    onClose,
    onCropComplete
}) => {
    const cropperRef = useRef(null);

    const handleCrop = () => {
        const cropper = cropperRef.current?.cropper;
        if (cropper) {
            cropper.getCroppedCanvas().toBlob((blob) => {
                if (blob) {
                    onCropComplete(blob);
                }
            }, "image/png");
        }
    };

    const imageUrl = file ? URL.createObjectURL(file) : null;
    console.log({ imageUrl })
    return (
        <ModalBox
            title="Crop Logo"
            isOpen={isOpen}
            onClose={onClose}
            isFooter={true}
            onCancel={onClose}
            onConfirm={handleCrop}
            confirmButtonText="Crop"
            confirmButtonType={false}
            description={
                <Box position="relative" width="100%" height="300px">
                    <Cropper
                        src={imageUrl}
                        ref={cropperRef}
                        style={{ height: "100%", width: "100%" }}
                        aspectRatio={undefined}
                        guides={true}
                        cropBoxResizable={true}
                        cropBoxMovable={true}
                        background={true}
                        modal={false}
                        zoomable={true}
                        scalable={true}
                        zoomOnWheel={true}
                        viewMode={1}
                    />
                </Box>
            }
        />
    );
};
